export default __webpack_public_path__ + "static/media/logo.6f5f96b1.png";